module.exports = __webpack_public_path__ + "static/img/RabbitG.7f54899.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/RabbitG.png
// module id = EpOK
// module chunks = 3